(function() {

    // REFACTORED 2026-03: Read per-variant laser power data from the JSON block
    // embedded by Liquid (class="laser-power-variant-data"). This replaces the old
    // approach of showing/hiding one .variant-power-data element per variant (50+
    // duplicate DOM nodes). Now Liquid renders the card/badge HTML exactly once and
    // this JS updates the watt values + row visibility on variant change.
    var laserPowerData = null;
    var dataEl = document.querySelector('script.laser-power-variant-data');
    if (dataEl) {
        try { laserPowerData = JSON.parse(dataEl.textContent); } catch(e) {}
    }

    // This function updates the laser power display based on the selected variant.
    function updateLaserPowerTable() {

        // use a timeout to wait for the url to update before we check it
        setTimeout(function() {
            // read variant ID from URL
            var urlParams = new URLSearchParams(window.location.search);
            var variantId = urlParams.get('variant');

            if (variantId && laserPowerData) {
                var data = laserPowerData.variants[variantId];

                // Update CO₂ watt number and show/hide the CO₂ row + badge
                document.querySelectorAll('.laser-power-co2-watt').forEach(function(el) {
                    el.textContent = data && data.co2 != null ? data.co2 : '';
                });
                document.querySelectorAll('.lasergrade-row--co2, .laser-badge--co2').forEach(function(el) {
                    el.style.display = (data && data.co2 != null) ? '' : 'none';
                });

                // Update Diode watt number and show/hide the Diode row + badge.
                // Diode is null for 9mm variants — the row is hidden for those.
                document.querySelectorAll('.laser-power-diode-watt').forEach(function(el) {
                    el.textContent = data && data.diode != null ? data.diode : '';
                });
                document.querySelectorAll('.lasergrade-row--diode, .laser-badge--diode').forEach(function(el) {
                    el.style.display = (data && data.diode != null) ? '' : 'none';
                });

                // Hide the entire container if this variant has no laser power data at all
                document.querySelectorAll('.laser-power-table-container, .lasergrade-info-container').forEach(function(container) {
                    var hasData = data && (data.co2 != null || data.diode != null);
                    container.classList.toggle('power-table-hidden', !hasData);
                });

                // Update thickness label from JSON — avoids querying by option name (which breaks cross-domain)
                if (data && data.dikte) {
                    document.querySelectorAll('.laser-power-dikte-label').forEach(function(el) {
                        el.textContent = data.dikte;
                    });
                }
            }
        }, 100);
    }

    // Run it once on page load:
    updateLaserPowerTable();

    // Maat dropdown: sync selected value to hidden radio buttons so variant-radios JS works
    document.querySelectorAll('.maat-select').forEach(function(select) {
        select.addEventListener('change', function() {
            var value = this.value;
            this.closest('fieldset').querySelectorAll('.maat-radio-hidden input[type="radio"]').forEach(function(radio) {
                if (radio.value === value) {
                    radio.checked = true;
                    radio.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
            updateLaserPowerTable();
        });
    });

    // Watch for variant change events by listening for clicks on the variant buttons
    document.addEventListener('click', function(event) {
        if (event.target && event.target.classList.contains('variant__button')) {
            updateLaserPowerTable();
        }
    });

})();
